<div class="uk-card uk-card-default" style="margin: 0 1rem 1rem 0"  *ngIf="stagiareData">
  <div class="uk-card-header uk-padding-small" [ngClass]="[headerBackground]">
    <div class="uk-grid-small uk-flex-middle uk-grid">
      <div class="uk-width-expand uk-width-5-6">
        <h3 class="uk-card-title uk-margin-remove-bottom primary-color " [ngClass]="[headerColor]">
          Stagiaires
        </h3>
      </div>
      <div class="info primary-color uk-width-1-6 k-text-right">
        <i
          class="k-icon k-i-info"
          uk-tooltip="Il s’agit de données propres aux stagiaires en fonction des filtres appliqués.</br>
                   Le taux de participation, le temps de formation par stagiaire et les Heures-stagiaires sont calculées</br>
                    en tenant compte des présences et absences reportées dans les sessions.</br>
                   Notez que pour être comptabilisé, un stagiaire doit être inscrit dans une session.</br>
                   Un même stagiaire inscrit dans plusieurs sessions est comptabilisé plusieurs fois.</br>
                   Masquez/affichez cet indicateur sur l’extranet du client à l’aide du switch situé en haut à droite de la tuile."
        ></i>
      </div>
    </div>
  </div>
  <div class="uk-card-body uk-padding-small">
      <p class="stats-sub-title margin-left-12">Nombre</p>
      <p class="margin-left-12">
        <span class="stats-number-before">{{ stagiareData.dataApp.nbApp || 0 | number: '0.0':'fr' }}</span>
      </p>
      <p class="stats-sub-title margin-left-12 ">Taux de participation</p>
      <div *ngIf="getParticipation(stagiareData) > 0 && !isInter">
        <p class="margin-left-12">
          <span class="stats-number-before">{{ getParticipation(stagiareData) }}%</span>
        </p>
        <ags-kendo-progress-bar
          *ngIf="!isInter"
          [height]="7"
          [style.width.%]="80"
          [type]="'value'"
          [value]="getParticipation(stagiareData) || 0"
          [max]="100"
          [min]="0"
        ></ags-kendo-progress-bar>
      </div>
      <div *ngIf="(getParticipation(stagiareData) === null || getParticipation(stagiareData) === 0) && !isInter">
        <p class="margin-left-12">
          <br />
          <span class="no-data">Donnée indisponible</span>
        </p>
        <ags-kendo-progress-bar
          *ngIf="!isInter"
          [height]="7"
          [style.width.%]="80"
          [type]="'value'"
          [value]="0"
          [max]="100"
          [min]="0"

        ></ags-kendo-progress-bar>
      </div>

      <div *ngIf="stagiareData.dataApp.taux > 0 && isInter">
        <p class="margin-left-12">
          <span class="stats-number-before">{{ stagiareData.dataApp.taux }}%</span>
        </p>
        <ags-kendo-progress-bar
          *ngIf="isInter"
          [height]="7"
          [style.width.%]="80"
          [type]="'value'"
          [value]="stagiareData.dataApp.taux || 0"
          [max]="100"
          [min]="0"
        ></ags-kendo-progress-bar>
      </div>

      <div *ngIf="(stagiareData.dataApp.taux === null || stagiareData.dataApp.taux === 0) && isInter">
        <p class="margin-left-12">
          <br />
          <span class="no-data">Donnée indisponible</span>
        </p>
        <ags-kendo-progress-bar
          *ngIf="isInter"
          [height]="7"
          [style.width.%]="80"
          [type]="'value'"
          [value]="0"
          [max]="100"
          [min]="0"
          [progressColor]="'#2CBB9D'"
        ></ags-kendo-progress-bar>
      </div>

      <p class="stats-sub-title  margin-left-12" style="padding-top: 25px;">Temps de formation/stagiaire</p>
      <p class="margin-left-12" *ngIf="stagiareData.totalHeure[0].heure">
          <span class="stats-number-before">{{
            stagiareData.totalHeure[0].heure.hours / stagiareData.dataApp.nbApp || 0 | number: '0.2'
            }}</span
          ><span class="stats-number-after margin-left-12"> heures</span>
      </p>
      <p class="margin-left-12" *ngIf="!stagiareData.totalHeure[0].heure">
        <span class="stats-number-before">{{ 0 | number: '0.2' }} </span>
        <span class="stats-number-after "> heures</span>
      </p>
      <p class="stats-sub-title margin-left-12">Heures-stagiaires (BPF)</p>
      <p class="margin-left-12" *ngIf="stagiareData.totalHeure[0].heure">
          <span class="stats-number-before">
            {{ stagiareData.totalHeureBPF[0].heure.hours || 0 | number: '0.0':'fr' }}</span
          >
      </p>
      <p class="margin-left-12"  *ngIf="!stagiareData.totalHeure[0].heure">
        <span class="stats-number-before"> {{ 0 | number: '0.0':'fr' }}</span>
      </p>
  </div>
</div>

